import { Popconfirm, Tooltip } from "antd"; // Ensure Ant Design is installed
import React from "react";

// import PropTypes from "prop-types";
import { TOOLTIPTEXT } from "../../../utilities/CommonText";
import ActionIcons from "../client/ActionIcons";

export const DeleteConfirmation = ({
  selectedCount,
  onConfirm,
  deleteLoading,
  okText = "Yes",
  cancelText = "No",
  okButtonClass = "bg-primary text-white border !border-primary hover:!bg-white hover:!text-primary",
  cancelButtonClass = "bg-white text-primary border !border-primary hover:!bg-primary hover:!text-white",
  actionButtonClass,
  deleteDescriptionName = "",
  deleteText = "Delete",
  type = "delete",
  extraDeleteText = "",
  buttonText,
}) => {
  return (
    <Tooltip
      title={
        deleteText == "archive"
          ? TOOLTIPTEXT.archive
          : deleteText == "candidate_profile"
            ? ""
            : TOOLTIPTEXT.delete
      }
    >
      <Popconfirm
        description={
          <div className="max-w-[300px] p-4">
            <p className="text-[16px] font-semibold leading-[normal] text-black">
              Are you sure you want to{" "}
              {deleteText == "archive" ? "archive" : "delete"} <br />
              {selectedCount}{" "}
              {selectedCount === 1
                ? `${deleteDescriptionName}?`
                : `${deleteDescriptionName}s? `}{" "}
              &nbsp;
              {extraDeleteText}
            </p>
          </div>
        }
        okButtonProps={{ className: okButtonClass }}
        cancelButtonProps={{ className: cancelButtonClass }}
        okText={okText}
        cancelText={cancelText}
        icon={null}
        onConfirm={onConfirm}
      >
        <button
          className={`group ${actionButtonClass} flex items-center gap-2`}
        >
          <ActionIcons isLoading={deleteLoading} type={type} />
          {buttonText ? (
            <span className="text-sm font-medium leading-normal text-red">
              {buttonText}
            </span>
          ) : null}
        </button>
      </Popconfirm>
    </Tooltip>
  );
};
